export default "__VITE_ASSET__1471891a__"